import React, { useState } from 'react';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import ViewListIcon from '@mui/icons-material/ViewList';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
    DashboardMenuItem,
    MenuItemLink,
    useTranslate,
    useSidebarState
} from 'react-admin';

import SubMenu from './SubMenu';

import { LanguageLabels } from '../components/Language';
import { FacultyLabels } from '../components/Faculty';
import { PartnerCollegeLabels } from '../components/PartnerCollege';
import { AwardingBodyLabels } from '../components/AwardingBody';
import { CampusLocationLabels } from '../components/CampusLocation';
import { CostCentreLabels } from '../components/CostCentre';
import { CreditLevelLabels } from '../components/CreditLevel';
import { CreditValueLabels } from '../components/CreditValue';
import { CountryLabels } from '../components/Country';
import { DeliveryInstitutionLabels } from '../components/DeliveryInstitution';
import { DurationLabels } from '../components/Duration';
import { HecosCodeLabels } from '../components/HecosCode';
import { JacsCodeLabes } from '../components/JacsCode';
import { ModeOfStudyLabels } from '../components/ModeOfStudy';
import { ModeOfDeliveryLabels } from '../components/ModeOfDelivery';
import { ModuleTypeLabels } from '../components/ModuleType';
import { PartnershipTypeLabels } from '../components/PartnershipType';
import { ProfessionalBodyLabels } from '../components/ProfessionalBody';
import { ProfessionalBodyTypeLabels } from '../components/ProfessionalBodyType';
import { QualificationAimLabels } from '../components/QualificationAim';
import { QualificationTypeLabels } from '../components/QualificationType';
import { StatusLabels } from '../components/StatusComponents';
import { InclusiveStatementLabels } from '../components/InclusiveCurriculumComponents';
import { ExternalExaminerLabels } from '../components/ExternalExaminer';
import { Tier4ArrangementLabels } from '../components/Tier4Arrangement';


const Menu = ({ onMenuClick }) => {
    const [menuStatic, setMenuStatic] = useState(false);
    const [menuCouse, setMenuCouse] = useState(true);
    const [menuModule, setMenuModule] = useState(true);
    const translate = useTranslate();
    const [open] = useSidebarState();

    return (
        <div>
            <DashboardMenuItem />
            <SubMenu
                handleToggle={() => setMenuCouse(!menuCouse)}
                isOpen={menuCouse}
                sidebarIsOpen={open}
                name={translate('myroot.courses')}
                icon={<AddBoxIcon />}>
                    <MenuItemLink
                        to={`/Course?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.coursesMenu')}
                        leftIcon={<ChevronRightIcon />}
                    />
                    <MenuItemLink
                        to={`/CourseInstance?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.courseInstances')}
                        leftIcon={<KeyboardArrowRightIcon />}
                    />
                    <MenuItemLink
                        to={`/AssociateCourse?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.associateCourses')}
                        leftIcon={<ChevronRightIcon />}
                    />
                    <MenuItemLink
                        to={`/ResearchCourse?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.researchCourses')}
                        leftIcon={<ChevronRightIcon />}
                    />
                    
            </SubMenu>
            <SubMenu
                handleToggle={() => setMenuModule(!menuModule)}
                isOpen={menuModule}
                sidebarIsOpen={open}
                name={translate('myroot.modules')}
                icon={<AddBoxIcon />}
                 
                >
                    <MenuItemLink
                        to={`/Module?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.modulesMenu')}
                        leftIcon={<ChevronRightIcon />}
                    />
                    <MenuItemLink
                        to={`/ResearchModule?filter=%7B%7D`}
                        sx={open ? {paddingLeft:3} : {}}
                        onClick={onMenuClick}
                        primaryText={translate('myroot.researchModules')}
                        leftIcon={<ChevronRightIcon />}
                    />
            </SubMenu>
            <SubMenu
                handleToggle={() => setMenuStatic(!menuStatic)}
                isOpen={menuStatic}
                sidebarIsOpen={open}
                name={translate('myroot.staticData')}
                icon={<AddBoxIcon />}  
            >
                <MenuItemLink
                    to={`/AscCode?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={translate('myroot.ascCode')}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Assessment?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={translate('myroot.assessments')}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/AwardingBody?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={AwardingBodyLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/CampusLocation?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={CampusLocationLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/CostCentre?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={CostCentreLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/CourseLevel?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={translate('myroot.CourseLevels')}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/CreditLevel?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={CreditLevelLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/CreditValue?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={CreditValueLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Country?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={CountryLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={'/ExternalExaminer?filter=%7B%7D'}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ExternalExaminerLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/DeliveryInstitution?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={DeliveryInstitutionLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Duration?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={DurationLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/HecosCode?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} :{}}
                    onClick={onMenuClick}
                    primaryText={HecosCodeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Faculty?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={FacultyLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/JacsCode?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={JacsCodeLabes.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Language?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={LanguageLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/ModeOfStudy?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ModeOfStudyLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/ModeOfDelivery?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ModeOfDeliveryLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/ModuleType?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ModuleTypeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/PartnerCollege`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={PartnerCollegeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />                
                <MenuItemLink
                    to={`/PartnershipType`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={PartnershipTypeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/ProfessionalBody?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ProfessionalBodyLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/ProfessionalBodyType?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={ProfessionalBodyTypeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/QualificationAim?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={QualificationAimLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/QualificationType?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={QualificationTypeLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/FacultyGroup?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={translate('myroot.FacultyGroup')}
                    leftIcon={<ChevronRightIcon />}
                />

                <MenuItemLink
                    to={`/FacultySubGroup?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={translate('myroot.FacultySubGroup')}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={`/Status?filter=%7B%7D`}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={StatusLabels.pageTitle}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={'/InclusiveStatement?filter=%7B%7D'}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={InclusiveStatementLabels.Title}
                    leftIcon={<ChevronRightIcon />}
                />
                <MenuItemLink
                    to={'/Tier4Arrangement?filter=%7B%7D'}
                    sx={open ? {paddingLeft:3} : {}}
                    onClick={onMenuClick}
                    primaryText={Tier4ArrangementLabels.Title}
                    leftIcon={<ChevronRightIcon />}
                />
            </SubMenu>
        </div>
    );
};

export default Menu;
